import React, {  useEffect, useState} from 'react';
import Tutorial from '../components/Tutorial';
import GamePage from './Game';
import MainMenuPage from './MainMenu';
export enum Windows {
	Nothing,
	MainMenu,
	Tutorial,
	PracticeScenarioA,
	PracticeScenarioB,
	PracticeScenarioC,
	PracticeScenarioD,
	TestScenarioA,
	TestScenarioB,
	TestScenarioC,
	TestScenarioD,
}
const MainPage = () => {
	const [windowToUse, setWindowToUse] = useState(Windows.MainMenu);
	var isInitializing: boolean = false;

	useEffect(() => {
		if(!isInitializing) {
			var url = new URL(window.location.href);
			var search_params = url.searchParams;
			var w: any = search_params.get('w');
			if(w && parseInt(w) !== Windows.Nothing) {
				setWindowToUse(parseInt(w));
			} else {
				setWindowToUse(Windows.MainMenu);
			}
			setTimeout(() => {
				(window as any)['uiContainerChanged']();
			}, 0);
			isInitializing = true;
		}
	})

	const updateWindow = (windowToUse: Windows): void => {
		//setWindow(window);
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', windowToUse.toString());

		url.search = search_params.toString();

		window.location.href = url.toString();
	}
	
	return (
		<div>
			{windowToUse === Windows.MainMenu ? <MainMenuPage updateWindow={updateWindow}></MainMenuPage> : (null)}
			{windowToUse === Windows.Tutorial ? <Tutorial updateWindow={updateWindow}></Tutorial>: (null)}
			{windowToUse === Windows.PracticeScenarioA ? <GamePage updateWindow={updateWindow} scenarioId="PracticeScenarioA"></GamePage>: (null)}
			{windowToUse === Windows.PracticeScenarioB ? <GamePage updateWindow={updateWindow} scenarioId="PracticeScenarioB"></GamePage>: (null)}
			{windowToUse === Windows.PracticeScenarioC ? <GamePage updateWindow={updateWindow} scenarioId="PracticeScenarioC"></GamePage>: (null)}
			{windowToUse === Windows.PracticeScenarioD ? <GamePage updateWindow={updateWindow} scenarioId="PracticeScenarioD"></GamePage>: (null)}
			{windowToUse === Windows.TestScenarioA ? <GamePage updateWindow={updateWindow} scenarioId="TestScenarioA"></GamePage>: (null)}
			{windowToUse === Windows.TestScenarioB ? <GamePage updateWindow={updateWindow} scenarioId="TestScenarioB"></GamePage>: (null)}
			{windowToUse === Windows.TestScenarioC ? <GamePage updateWindow={updateWindow} scenarioId="TestScenarioC"></GamePage>: (null)}
			{windowToUse === Windows.TestScenarioD ? <GamePage updateWindow={updateWindow} scenarioId="TestScenarioD"></GamePage>: (null)}
		</div>
	);
};

export default MainPage;
